import { createAction, props } from '@ngrx/store';
import { Group } from '@shared/models/group';

export const selectAddUserGroup = createAction('[Users] Select Add User Group', props<{ group: Partial<Group> }>());
